import { appConstants } from '../constants/app';
import { sites, offers, settings, publicRequest } from '../services/ApiService';

// Установка глобальных настроек
export const setGlobalSettings = settings => ({
  type: appConstants.SET_GLOBAL_SETTINGS_SUCCESS,
  settings,
});

// Список стран
export const startSetCountriesList = () => dispatch => {
  return publicRequest
      .getCountries()
      .then(data => dispatch(setGlobalSettings({ countries: data.items })))
      .catch(err => dispatch({ type: appConstants.SET_GLOBAL_SETTINGS_FAILURE }));
};

export const setAuthSettings = settings => ({
  type: appConstants.SET_AUTH_SETTINGS_SUCCESS,
  settings,
});

export const startSetAuthSettings = () => dispatch => 
  publicRequest.getSettings().then(({items}) => dispatch(setAuthSettings(items)));